import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { editCards } from '../../actions'
import Button from '@material-ui/core/Button';

import { _ } from '../../functions/translator.js';

class ReleaserFailResponse extends React.Component{

    render(){ 
        let renderedCardsGroups = []
        if (this.props.responseData.not_protocol) {
            this.props.responseData.not_protocol.forEach(cardsGroupId => {
                let cardsGroupData = this.props.cardsGroupsData[cardsGroupId]
                if (cardsGroupData) {
                    renderedCardsGroups.push(<tr>
                        <td>{cardsGroupData.attributes.index}</td>
                        <td>{_('No tiene un protocolo asociado')}</td>
                    </tr>)
                }
            })
        }
        if (this.props.responseData.not_team) {
            this.props.responseData.not_team.forEach(cardsGroupId => {
                let cardsGroupData = this.props.cardsGroupsData[cardsGroupId]
                if (cardsGroupData) {
                    renderedCardsGroups.push(<tr>
                        <td>{cardsGroupData.attributes.index}</td>
                        <td>{_('No tiene un equipo asociado')}</td>
                    </tr>)
                }
            })
        }
        if (this.props.responseData.not_releasable) {
            this.props.responseData.not_releasable.forEach(cardsGroupId => {
                let cardsGroupData = this.props.cardsGroupsData[cardsGroupId]
                if (cardsGroupData) {
                    renderedCardsGroups.push(<tr>
                        <td>{cardsGroupData.attributes.index}</td>
                        <td>{_('No se ha completado un protocolo anterior')}</td>
                    </tr>)
                }
            })
        }
        return (
            <div> 
                <table class="table">
                    <thead>
                        <tr>
                            <th>{_("ID tarjeta")}</th>
                            <th>Error</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderedCardsGroups}
                    </tbody>
                </table>
                {this.props.responseData.not_team && 
                    <div className='d-flex justify-content-center mt-1 mb-2'>
                        <Button 
                            variant="contained" 
                            className='confirm-success-button'
                            href={'/teams?project_id=' + window.project_id}
                            disabled={false}>
                            { _('Editar Equipos') }
                        </Button>
                    </div>
                }
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        responseData : state.responseData,
        cardsGroupsData : state.projectData.cards_groups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        editCards : editCards,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ReleaserFailResponse)